module.exports = __webpack_public_path__ + "img/1534733036.096f0681.jpg";